/*global ajaxurl */
import AOS from 'aos';
import axios from 'axios';
import Qs from 'qs';

export default {
  init() {
    // init animations
    AOS.init();

    $("#creed-tabs a").mouseenter(function () {
      console.log("mouseenter");
      $("#creed-tabs a").removeClass("active");
      $(this).addClass("active");
      const imageSrc = $(this).data("image");
      if (imageSrc) {
        $("#range").attr("src", imageSrc);
      }
    });

    // $("#sign-up-iframe").on("load", function () {
    //   const frame = document.getElementById("sign-up-iframe");
    //   frame.contentWindow.postMessage("test message", "*");
    // });

    // JavaScript to be fired on all pages

    // Collapsible Content
    $(".collapse-controller").click(function () {
      const id = $(this).attr("id");
      const target = id.substring(0, id.length - "-controller".length);
      $(this).toggleClass("active");
      $("#" + target).slideToggle();
    });

    // Smooth scroll
    $("a.smooth-scroll, .smooth-scroll a").click(function (event) {
      if (this.hash !== "" && this.pathname === window.location.pathname) {
        event.preventDefault();
        var hash = this.hash;
        $("html, body").animate(
          {
            scrollTop: $(hash).offset().top - $("header").height(),
          },
          600
        );
      }
    });

    // Video modal
    let $videoSrc;
    $(".video-btn").click(function () {
      $videoSrc = $(this).data("src");
    });

    $("#videoModal").on("shown.bs.modal", function () {
      $("#video").attr(
        "src",
        $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0"
      );
    });

    $("#videoModal").on("hide.bs.modal", function () {
      $("#video").attr("src", $videoSrc);
    });

    $(document).on("click", ".hamburger", function () {
      $(this).toggleClass("is-active");
      if ($(this).hasClass("hamburger--spring")) {
        $(".nav-primary").slideToggle();
        $("nav.navigation").toggleClass("pb-0 mb-0");
      } else {
        $(this).prev(".sub-menu").slideToggle();
      }
    });

    // Remove preload class on load to prevent css animations getting triggered on load
    $(window).load(function () {
      $("body").removeClass("preload");
    });

    // Append a toggle button to navigaiton items with children
    $(".menu-item-has-children").each(function () {
      $(this).append(
        '<button class="hamburger hamburger--minus" type="button"><span class="hamburger-box"><span class="hamburger-inner"></span></span></button>'
      );
    });

    $(document).on(
      "mouseenter",
      "li.products, .dropdown-products",
      function () {
        $(".dropdown-products").addClass("show");
      }
    );

    $(document).on(
      "mouseleave",
      "li.products, .dropdown-products",
      function () {
        $(".dropdown-products").removeClass("show");
      }
    );

    $(document).on(
      "mouseenter",
      "li.medical-education, .dropdown-medical-education",
      function () {
        $(".dropdown-medical-education").addClass("show");
      }
    );

    $(document).on(
      "mouseleave",
      "li.medical-education, .dropdown-medical-education",
      function () {
        $(".dropdown-medical-education").removeClass("show");
      }
    );

    $(document).on(
      "mouseenter",
      "li.solutions, .dropdown-solutions",
      function () {
        $(".dropdown-solutions").addClass("show");
      }
    );

    $(document).on(
      "mouseleave",
      "li.solutions, .dropdown-solutions",
      function () {
        $(".dropdown-solutions").removeClass("show");
      }
    );

    // Change products menu image on hover
    $(".nav-by-system a").hover(function () {
      $(".nav-by-system a").each(function () {
        $(this).removeClass("active");
      });

      $(this).addClass("active");

      let index = $(this).data("index");
      $(this)
        .closest(".dropdown-inner")
        .find("figure")
        .each(function () {
          $(this).removeClass("visible");
          if (index == $(this).data("index")) {
            $(this).addClass("visible");
          }
        });
    });

    // Change products menu image on hover
    $(".medical-education-nav a").hover(function () {
      $(".medical-education-nav a").each(function () {
        $(this).removeClass("active");
      });

      $(this).addClass("active");

      let index = $(this).data("index");
      $(this)
        .closest(".dropdown-inner")
        .find(".sub-menu-item")
        .each(function () {
          $(this).removeClass("visible");
          if (index == $(this).data("index")) {
            $(this).addClass("visible");
          }
        });
    });

    // Change solutions menu image on hover
    $(".solutions-nav a").hover(function () {
      $(".solutions-nav a").each(function () {
        $(this).removeClass("active");
      });

      $(this).addClass("active");

      let index = $(this).data("index");
      $(this)
        .closest(".dropdown-inner")
        .find(".sub-menu-item")
        .each(function () {
          $(this).removeClass("visible");
          if (index == $(this).data("index")) {
            $(this).addClass("visible");
          }
        });
    });

    // Lazy load images under the fold
    $(function () {
      $(".lazy").Lazy();
    });

    // Init masonary grid
    $(window).on("load", function () {
      $("#masonary").masonry({
        itemSelector: ".grid-item",
        horizontalOrder: true,
        transitionDuration: 0,
      });
    });

    // Prvent css transitions on load
    $(window).on("load", function () {
      $(".css-transitions-after-load").each(function (index, element) {
        $(element).removeClass("css-transitions-after-load");
      });
    });

    // Init products slider
    $("#product-slider").slick({
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $(".prev"),
      nextArrow: $(".next"),
      lazyLoad: "ondemand",
      responsive: [
        {
          breakpoint: 1650,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".carousel").each(function () {
      const carousel = $(this);
      const accordion = carousel.closest(".accordion");
      $(this)
        .find(".product-slide")
        .each(function () {
          $(this).click(function () {
            console.log("click slide", $(this).data("slide-id"));
            const slideID = $(this).data("slide-id");
            const slideContent = $(this)
              .closest(".accordion")
              .find("#slide-content-" + slideID);
            $(this)
              .closest(".accordion")
              .find(".slide-content")
              .each(function () {
                if ($(this).attr("id") !== "slide-content-" + slideID) {
                  $(this).removeClass("active");
                  $(this).slideUp();
                }
              });

            if (slideContent.hasClass("active")) {
              slideContent.removeClass("active");
              slideContent.slideUp();
            } else {
              slideContent.addClass("active");
              slideContent.slideDown();
            }
          });
        });
      carousel.on("afterChange init", function (event, slick) {
        const slides = slick.activeBreakpoint
          ? slick.breakpointSettings[slick.activeBreakpoint].slidesToShow
          : 5;
        if (slides > slick.slideCount) {
          $(accordion.find(".arrows")).hide();
        }
        carousel.find(".slick-slide").removeClass("first");
        carousel.find(".slick-slide").removeClass("visible");
        carousel.find(".slick-slide.slick-active").addClass("visible");
        carousel.find(".slick-slide.slick-active").each(function () {
          const slideIndex = $(this).data("slick-index");
          carousel
            .find(
              '[data-slick-index="' + (slideIndex + slick.slideCount) + '"]'
            )
            .addClass("visible");
          carousel
            .find(
              '[data-slick-index="' + (slideIndex - slick.slideCount) + '"]'
            )
            .addClass("visible");
        });
        if (slick.slideCount > 5) {
          carousel.find(".slick-active:first").addClass("first");
          carousel.find(".slick-active:last").addClass("first");
        }
      });
      carousel.slick({
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        prevArrow: accordion.find(".prev"),
        nextArrow: accordion.find(".next"),
        lazyLoad: "ondemand",
        onAfterChange: function (e) {
          console.log(e);
          $(".slick-active").prev().addClass("prev");
          $(".slick-active").next().addClass("next");
        },
        responsive: [
          {
            breakpoint: 1650,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
              infinite: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });
    });

    $(".gallery-carousel .blocks-gallery-grid").each(function () {
      const carousel = $(this);
      const gallery = carousel.closest(".gallery-carousel");
      const initalSlide = carousel.data("initial-slide")
        ? carousel.data("initial-slide")
        : 0;

      carousel.on("afterChange init", function (event, slick) {
        const currentSlide = slick["currentSlide"];
        const applications = $(".applications");
        applications.find("strong").removeClass("color--green");
        applications.find("p").removeClass("active");
        const content = $(applications.find("p")[currentSlide]);
        content.find("strong").addClass("color--green");
        content.find("strong").addClass("active");
      });

      carousel.slick({
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: initalSlide,
        arrows: true,
        prevArrow: gallery.find(".prev"),
        nextArrow: gallery.find(".next"),
        lazyLoad: "ondemand",
        onAfterChange: function () {
          $(".slick-active").prev().addClass("prev");
          $(".slick-active").next().addClass("next");
        },
      });
    });

    /**
     * Show/hide Back to top button
     */
    $(window).scroll(function () {
      if ($(document).scrollTop() > 100) {
        $("#top").addClass("visible");
      } else {
        $("#top").removeClass("visible");
      }
    });

    /**
     * Scroll to top
     */
    $("#top").click(function () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });

    $(".tray-categories li.title div").click(function () {
      $(this).children().eq(1).toggleClass("flip");
      $(this).parent().children().eq(1).slideToggle();
      let trayName = $(this).data("trayname");
      $(".tray-images .tray-wrap").each(function () {
        let trayImage = $(this).attr("data-trayimage");
        if (trayName == trayImage) {
          $(this).fadeIn();
        } else {
          $(this).fadeOut();
        }
      });
    });

    /**
     * On scroll set fixed header
     */
    $(window).scroll(function () {
      const sticky = $(
        ".banner-pink .nav-wrap, .banner-image .nav-wrap, .banner-blue .nav-wrap, .banner-green .nav-wrap"
      );
      const scroll = $(window).scrollTop();
      const body = $("body");
      const stickyHeight = sticky.height();

      if (scroll >= 100) {
        sticky.addClass("fixed");
        body.css("margin-top", stickyHeight);
      } else {
        sticky.removeClass("fixed");
        body.css("margin-top", 0);
      }
    });

    // Update svg background fill colours when using as img tag
    $(".svg").each(function () {
      var img = $(this);
      var imgID = img.attr("id");
      var imgClass = img.attr("class");
      var imgURL = img.attr("src");

      $.get(
        imgURL,
        function (data) {
          var svg = $(data).find("svg");
          if (typeof imgID !== "undefined") {
            svg = svg.attr("id", imgID);
          }
          if (typeof imgClass !== "undefined") {
            svg = svg.attr("class", imgClass + " replaced-svg");
          }
          svg = svg.removeAttr("xmlns:a");
          if (!svg.attr("viewBox") && svg.attr("height") && svg.attr("width")) {
            svg.attr(
              "viewBox",
              "0 0 " + svg.attr("height") + " " + svg.attr("width")
            );
          }
          img.replaceWith(svg);
        },
        "xml"
      );
    });

    // Toggle contact sales rep form
    $("#contact-sales").click(function (e) {
      e.preventDefault();
      $(".contact-form").slideToggle();
    });

    $(".interactive-tray img[data-part]").each(function () {
      $(this).mouseenter(function () {
        let parent = $(this).parent();

        let tray = parent.children().eq(0);
        tray.addClass("opacity");
        let part = $(this).data("part");
        let parentClass = parent.prop("className");
        $("." + parentClass + " img[data-part]").each(function () {
          if ($(this).data("part") != part) {
            $(this).addClass("opacity");
          }
        });

        let table = parent
          .closest("section")
          .find("#interactive-table tr, .interactive-table tr");
        console.log("table", parent.closest("section"));
        $(table).each(function () {
          let partArray = part.split(" ");
          if (jQuery.inArray($(this).data("row"), partArray) === -1) {
            $(this).addClass("grey");
          }
        });
      });
      $(this).mouseleave(function () {
        let parent = $(this).parent();
        let tray = parent.children().eq(0);
        tray.removeClass("opacity");
        let parentClass = parent.prop("className");
        $("." + parentClass + " img[data-part]").each(function () {
          $(this).removeClass("opacity");
        });
        let table = parent
          .closest("section")
          .find("#interactive-table tr, .interactive-table tr");
        $(table).each(function () {
          $(this).removeClass("grey");
        });
      });
    });

    /** Displays site alert */
    function site_alert(enabled) {
      var now = new Date();
      var expiryDate = now.setDate(now.getDate() + 1);
      now.setTime(expiryDate);

      if (enabled == false) {
        $(".site-alert").addClass("hidden");
        document.cookie =
          "site_alert=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
      }

      if (enabled == true) {
        $(".site-alert").removeClass("hidden");
        document.cookie =
          "site_alert=false;expires=" + now.toGMTString() + ";path=/";
      }
    }

    $(".site-alert .close").on("click", function () {
      site_alert(false);
    });

    $(".site-alert .open").on("click", function () {
      site_alert(true);
    });

    if (document.cookie.indexOf("site_alert=") == -1) {
      $(".site-alert").addClass("hidden");
    }

    function daysInMonth(month, year) {
      let d = new Date(year, month + 1, 0);
      return d.getDate();
    }

    function positionEvents(category) {
      $(".day-content").html("");
      $("#calendar .events .event").each(function () {
        const date = $(this).data("date");
        const categories = $(this).data("categories");
        const dateContainer = $("#" + date);

        if (category && !categories.includes(category)) {
          return;
        }

        const duration = $(this).data("duration")
          ? $(this).data("duration")
          : 0;

        if ($("#" + date).length) {
          let element = dateContainer;
          // element.find('.day-content').append(`<div class="event" style="">${$(this).html()}</div>`);
          // element = dateContainer.next();
          for (let i = 0; i <= duration; i++) {
            let position = "";
            if (i === 0) {
              position = "first";
            } else if (i === duration) {
              position = "last";
            }
            element
              .find(".day-content")
              .append(
                `<div class="event ${position}" style="">${$(
                  this
                ).html()}</div>`
              );
            element = element.next();
          }
        }
      });
    }

    // Calendar
    function getSelectedCategory(element = null) {
      if (!element) {
        element = ".events-block .filter .nav-link.active";
      }
      const selectedCategory = $(element);
      if (selectedCategory) {
        const href = selectedCategory.attr("href");
        const subItem = $(href).find(".category-link.active");
        if (subItem.length) {
          return subItem.data("category");
        }
        return selectedCategory.data("category");
      }
      return null;
    }

    function loadCalendarDays() {
      const calendar = $("#calendar");
      const months = calendar.data("months");
      const currentMonth = calendar.data("month");
      const currentYear = calendar.data("year");

      if (!currentMonth) return;

      calendar.find(".current-date .month").text(months[currentMonth]);
      calendar.find(".current-date .year").text(currentYear);

      $("#calendarDays").html("");

      const tmpDate = new Date(currentYear, currentMonth, 0);
      const num = daysInMonth(currentMonth, currentYear);
      const dayofweek = tmpDate.getDay(); // find where to start calendar day of week

      const lastMonthCount = new Date(currentYear, currentMonth, 0).getDate();
      let count = 0;

      // create day prefixes
      if (dayofweek < 6) {
        for (var i = 0; i <= dayofweek; i++) {
          count++;
          const number = lastMonthCount - (dayofweek - i);
          $("#calendarDays").append(`
          <div id=${
            number + "-" + Number(currentMonth) + "-" + currentYear
          } class="day blank">
            <span class="day-title">${number}</span>
            <div class="day-content"></div>
          </div>
        `);
        }
      }

      // render the rest of the days
      for (var day = 0; day < num; day++) {
        count++;
        $("#calendarDays").append(`
        <div id=${
          day + 1 + "-" + Number(currentMonth + 1) + "-" + currentYear
        } class="day">
          <span class="day-title">${day + 1}</span>
          <div class="day-content"></div>
        </div>
        `);
      }

      let nextMonthDay = 1;
      while (count % 7) {
        count++;

        $("#calendarDays").append(`
        <div id=${
          nextMonthDay + "-" + Number(currentMonth + 2) + "-" + currentYear
        } class="day blank">
          <span class="day-title">${nextMonthDay}</span>
          <div class="day-content"></div>
        </div>
        `);
        nextMonthDay++;
      }

      const selectedCategory = getSelectedCategory();
      positionEvents(selectedCategory);
    }

    function updateCalendar(monthChange) {
      const calendar = $("#calendar");
      let month = calendar.data("month") + monthChange;
      let year = calendar.data("year");
      if (month < 0) {
        month += 12;
        year -= 1;
      } else if (month > 11) {
        month -= 12;
        year += 1;
      }
      calendar.data("month", month);
      calendar.data("year", year);
      loadCalendarDays();
    }

    $(".calendar-dates .arrow-left").click(function (e) {
      e.preventDefault();
      updateCalendar(-1);
    });

    $(".calendar-dates .arrow-right").click(function (e) {
      e.preventDefault();
      updateCalendar(1);
    });

    $(".calendar-views .list-view").click(function (e) {
      e.preventDefault();
      $(".event-view.calendar-view").hide();
      $(".calendar-views .calendar-view").removeClass("active");
      $(".event-view.list-view").show();
      $(".calendar-views .list-view").addClass("active");
    });

    $(".calendar-views .calendar-view").click(function (e) {
      e.preventDefault();
      $(".event-view.list-view").hide();
      $(".calendar-views .list-view").removeClass("active");
      $(".event-view.calendar-view").show();
      $(".calendar-views .calendar-view").addClass("active");
    });

    function updateListEvents(category) {
      $(".events-block .event-view.list-view .event-date").each(function () {
        const categories = $(this).data("categories");
        if (category && !categories.includes(category)) {
          $(this).fadeOut();
        } else {
          $(this).fadeIn();
        }
      });
    }

    $(
      ".events-block .filter .category-link, .events-block .sub-filter .category-link"
    ).click(function () {
      const slug = $(this).data("slug");

      if (slug != "gfas") {
        $(".gfas-events").fadeOut();
        const selectedCategory = getSelectedCategory(this);
        positionEvents(selectedCategory);
        updateListEvents(selectedCategory);
        return true;
      }

      $(".event-date").fadeOut();
      $(".gfas-events").fadeIn();
    });

    function transitionLogos() {
      $(".transition-logos .transition-logo").each(function () {
        if ($(this).find(".fade-text .text").length < 2) {
          return;
        }
        var active = $(this).find(".fade-text .text.active").length
          ? $(this).find(".fade-text .text.active")
          : $(this).find(".fade-text .text:first");
        var next = active.next().length
          ? active.next()
          : $(this).find(".fade-text .text:first");

        next.addClass("active").animate({ opacity: 1 }, 500);
        active.animate({ opacity: 0 }, 500, function () {
          active.removeClass("active");
        });
      });
    }

    $(window).on("load", function () {
      // Set up calendar
      loadCalendarDays();
      const selectedCategory = getSelectedCategory();
      updateListEvents(selectedCategory);
      $(".event-view.list-view").show();
      $(".calendar-views .list-view").addClass("active");
      $(".gfas-events").hide();

      // Transition logos
      setInterval(transitionLogos, 4000);
    });

    /**
     * Airlock calculator sum one
     * @param {*} value1
     * @param {*} value2
     */
    function calculatorSumOne(value1, value2) {
      const total = Number(value1) * Number(value2);
      return total;
    }

    /**
     * Airlock calculator sum two
     * @param {*} value1
     * @param {*} value2
     * @param {*} value3
     */
    function calculatorSumTwo(value1, value2, value3) {
      const total = Number(value1) * Number(value2) + Number(value3);
      return total;
    }

    /**
     * Airlock calculator sum three
     * @param {*} value1
     * @param {*} value2
     */
    function calculatorSumThree(value1, value2) {
      const total = Number(value1) + Number(value2);
      return total;
    }

    /**
     * Total savings sum
     * @param {*} value1
     * @param {*} value2
     */
    function calculatorTotals(value1, value2) {
      value1 = value1.replace("$", "");
      value2 = value2.replace("$", "");

      const totalSavings = Number(value1) - Number(value2);
      $("input[name=total_savings]").val("$" + totalSavings);
      let percentage = (totalSavings / Number(value1)) * 100;
      percentage = parseFloat(percentage).toFixed(2);
      $("input[name=percentage_savings]").val(percentage + "%");
    }

    /**
     * On key up set no of cases
     */
    $("input[name=current_cost_per_case]").keyup(function () {
      const currentCostPerCase = $(this).val();
      $("input[name=current_no_cases]").val(currentCostPerCase);
    });

    /**
     * on key up call calculatorSumOne
     */
    $("input[name=current_cases_by_procedure]").keyup(function () {
      const currentCasesByProcedure = $(this).val();
      const currentCostPerCase = $("input[name=current_cost_per_case]").val();
      const total = calculatorSumOne(
        currentCostPerCase,
        currentCasesByProcedure
      );
      $("input[name=current_total_1]").val(total);
    });

    /**
     * on key up call calculatorSumTwo
     */
    $("input[name=current_decontam]").keyup(function () {
      const currentDecontam = $(this).val();
      const currentNoCases = $("input[name=current_no_cases]").val();
      const currentTotal1 = $("input[name=current_total_1]").val();
      const total = calculatorSumTwo(
        currentDecontam,
        currentNoCases,
        currentTotal1
      );
      $("input[name=current_total_2]").val(total);
    });

    /**
     * on key up call calculatorSumThree
     */
    $("input[name=current_annual_loss]").keyup(function () {
      const currentAnnualLoss = $("input[name=current_annual_loss]").val();
      const currentTotal2 = $("input[name=current_total_2]").val();
      const total = calculatorSumThree(currentTotal2, currentAnnualLoss);
      $("input[name=current_total_spend]").val(total);
    });

    /**
     * On key up set no of cases
     */
    $("input[name=airlock_cost_per_case]").keyup(function () {
      const cases = $(this).val();
      $("input[name=airlock_no_cases]").val(cases);
    });

    /**
     * on key up call calculatorSumOne
     */
    $("input[name=airlock_cases_by_procedure]").keyup(function () {
      const airlockCasesByProcedure = $(this).val();
      const airlockCostPerCase = $("input[name=airlock_cost_per_case]").val();
      const total1 = calculatorSumOne(
        airlockCostPerCase,
        airlockCasesByProcedure
      );
      $("input[name=airlock_total_1]").val(total1);

      const airlockDecontam = $("input[name=airlock_decontam]").val();
      const airlockNoCases = $("input[name=airlock_no_cases]").val();
      const airlockTotal1 = $("input[name=airlock_total_1]").val();
      const total2 = calculatorSumTwo(
        airlockDecontam,
        airlockNoCases,
        airlockTotal1
      );
      $("input[name=airlock_total_2]").val(total2);
    });

    /**
     * on key up call calculatorSumThree
     */
    $("input[name=airlock_annual_loss]").keyup(function () {
      const airlockAnnualLoss = $("input[name=airlock_annual_loss]").val();
      const airlockTotal2 = $("input[name=airlock_total_2]").val();
      const total = calculatorSumThree(airlockTotal2, airlockAnnualLoss);
      $("input[name=airlock_total_spend]").val(total);
    });

    /**
     * Calculator form submit
     */
    $("form#calculator").submit(function (e) {
      e.preventDefault();

      // Current input
      let currentCostPerCase = $("input[name=current_cost_per_case]").val();
      let currentCasesByProcedure = $(
        "input[name=current_cases_by_procedure]"
      ).val();
      let currentTotal1 = $("input[name=current_total_1]");
      let currentDecontam = $("input[name=current_decontam]").val();
      let currentNoCases = $("input[name=current_no_cases]").val();
      let currentTotal2 = $("input[name=current_total_2]");
      let currentAnnualLoss = $("input[name=current_annual_loss]").val();
      let currentTotalSpend = $("input[name=current_total_spend]");

      const currentSum1 = calculatorSumOne(
        currentCostPerCase,
        currentCasesByProcedure
      );
      currentTotal1.val(currentSum1);

      const currentSum2 = calculatorSumTwo(
        currentDecontam,
        currentNoCases,
        currentSum1
      );
      currentTotal2.val(currentSum2);

      const currentSum3 = calculatorSumThree(currentSum2, currentAnnualLoss);
      currentTotalSpend.val("$" + currentSum3);

      //Airlock input
      let airlockCostPerCase = $("input[name=airlock_cost_per_case]").val();
      let airlockCasesByProcedure = $(
        "input[name=airlock_cases_by_procedure]"
      ).val();
      let airlockTotal1 = $("input[name=airlock_total_1]");
      let airlockDecontam = $("input[name=airlock_decontam]").val();
      let airlockNoCases = $("input[name=airlock_no_cases]").val();
      let airlockTotal2 = $("input[name=airlock_total_2]");
      let airlockAnnualLoss = $("input[name=airlock_annual_loss]").val();
      let airlockTotalSpend = $("input[name=airlock_total_spend]");

      const airlockSum1 = calculatorSumOne(
        airlockCostPerCase,
        airlockCasesByProcedure
      );
      airlockTotal1.val(airlockSum1);

      const airlockSum2 = calculatorSumTwo(
        airlockDecontam,
        airlockNoCases,
        airlockSum1
      );
      airlockTotal2.val(airlockSum2);

      const airlockSum3 = calculatorSumThree(airlockSum2, airlockAnnualLoss);
      airlockTotalSpend.val("$" + airlockSum3);

      calculatorTotals(currentTotalSpend.val(), airlockTotalSpend.val());
    });

    $("#form_creed_landing_page .acf-date-picker .hasDatepicker").attr(
      "placeholder",
      "Date"
    );
    $("#form_creed_landing_page .acf-time-picker .hasDatepicker").attr(
      "placeholder",
      "Time"
    );
    $("#form_presslock_landing_page .acf-date-picker .hasDatepicker").attr(
      "placeholder",
      "Date"
    );
    $("#form_presslock_landing_page .acf-time-picker .hasDatepicker").attr(
      "placeholder",
      "Time"
    );
    $("#form_fusionframe_landing_page .acf-date-picker .hasDatepicker").attr(
      "placeholder",
      "Date"
    );
    $("#form_fusionframe_landing_page .acf-time-picker .hasDatepicker").attr(
      "placeholder",
      "Time"
    );
    $("#form_hallux_valgus .acf-date-picker .hasDatepicker").attr(
      "placeholder",
      "Date"
    );
    $("#form_hallux_valgus .acf-time-picker .hasDatepicker").attr(
      "placeholder",
      "Time"
    );
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    const redirectCode = (countryCode) => {
      switch (countryCode) {
        case "FR":
          return "FR";
        case "US":
          return "US";
        default:
          return "INT";
      }
    };

    const location = (countryCode, language) => {
      const isFrench = language === "fr";
      switch (countryCode) {
        case "FR":
          return isFrench
            ? "la <strong>France</strong>"
            : "<strong>France</strong>";
        case "US":
          return isFrench ? "les <strong>US</strong>" : "<strong>US</strong>";
        default:
          return isFrench
            ? "<strong>l'international (hors US)</strong>"
            : "<strong>outside the US</strong>";
      }
    };

    const triggerEnovisModal = () => {
      if ($("#enovisModal").length) {
        $("#enovisModal").modal("show");
      }
    };

    if ($("#redirectModal").length) {
      const htmlLang = $("html")[0].lang;
      const lang = htmlLang && htmlLang === "fr-FR" ? "fr" : "en";

      fetch("https://ipapi.co/json")
        .then((response) => response.json())
        .then((data) => {
          console.log(data);

          const countryCode = data.country_code;
          const redirectModalCountryElement = $(
            "#redirectModalCountryName span"
          );
          if (redirectModalCountryElement.length) {
            const countryName = location(countryCode, lang);
            redirectModalCountryElement.html(countryName);
          }
          if (countryCode) {
            const redirectRegion = redirectCode(countryCode);
            const regionElement = $(
              '.region-redirect[data-region="' + redirectRegion + '"]'
            );
            if (regionElement.length) {
              regionElement.removeClass("d-none");
              $("#redirectModal").modal({
                backdrop: "static",
                keyboard: false,
              });
            } else {
              triggerEnovisModal();
            }
          } else {
            triggerEnovisModal();
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          triggerEnovisModal();
        });

      $("#redirectModal").on("hidden.bs.modal", function () {
        let now = new Date();
        const expiry = now.setTime(now.getTime() + 60 * 60 * 24 * 180);
        now.setTime(expiry);
        document.cookie =
          "redirect=true;expires=" + now.toGMTString() + ";path=/";
        triggerEnovisModal();
      });

      $("#redirectModal .redirect-flag").hover(
        function () {
          $(this)
            .closest(".redirect-flags")
            .find(".redirect-flag")
            .addClass("inactive");
          $(this).removeClass("inactive");
        },
        function () {
          $(this)
            .closest(".redirect-flags")
            .find(".redirect-flag")
            .removeClass("inactive");
        }
      );
    } else {
      triggerEnovisModal();
    }

    $("#enovisModal").on("hidden.bs.modal", function () {
      let now = new Date();
      const expiry = now.setTime(now.getTime() + 60 * 60 * 24 * 180);
      now.setTime(expiry);
      document.cookie = "enovis=true;expires=" + now.toGMTString() + ";path=/";

      $("body").trigger("focus");
    });

    $("#enovisLink").on("click", function (e) {
      e.preventDefault();

      let now = new Date();
      const expiry = now.setTime(now.getTime() + 60 * 60 * 24 * 180);
      now.setTime(expiry);
      document.cookie = "enovis=true;expires=" + now.toGMTString() + ";path=/";

      const href = $(this).attr("href");
      window.open(href, "_blank").focus();
    });

    if (document.cookie.indexOf("modal=") == -1) {
      $("#productModal").modal("show");
    }

    $("#productModal").on("hidden.bs.modal", function () {
      let now = new Date();
      const expiry = now.setTime(now.getTime() + 60 * 60 * 24 * 180);
      now.setTime(expiry);
      document.cookie = "modal=true;expires=" + now.toGMTString() + ";path=/";
    });

    $("#europeSelect").select2();

    $("#europeButton").on("click", function () {
      $("#countrySelect").removeClass("d-none");
    });

    $("#europeSelect").on("change", function () {
      const product = $(this).attr("product");
      const lang = $(this).val();

      let data = {
        action: "get_information_leaflet",
        product: product,
        lang: lang,
      };

      axios.post(ajaxurl, Qs.stringify(data)).then((response) => {
        $("#europeResults").empty();
        $("#europeResults").append(response.data.data.template);
      });
    });

    // Play hover videos on hover
    $(document).ready(function () {
      $(".hover-video-block").on("hover click", function () {
        const video = $(this).find(".embed-responsive");
        if (video.hasClass("visible")) {
          return;
        }
        const iframe = video.find("iframe");
        const currentUrl = iframe.attr("src");
        const url = new URL(currentUrl);
        url.searchParams.set("autoplay", "1");
        iframe.attr("src", url.href);
        setTimeout(function () {
          video.addClass("visible");
        }, 200);
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js